import axios from "axios";

export default axios.create({
    baseURL: process.env.REACT_APP_IMROOM_API_URL,
    crossDomain: true,
    headers: {
        'Access-Control-Allow-Origin' : '*'
    }
})